import type { BuildMarkerSummary } from '../../games/playtest-sessions-data.js';

// Compact display string for just the build identifier portion of a
// marker (no stage, no decoration). Collapses to a single value when
// the studio used the same string in both label and version slots.
// The dev stage is rendered as a sibling tag by the calling component.
export function formatMarkerBuild(marker: BuildMarkerSummary): string {
  if (marker.label === marker.version) return marker.label;
  return `${marker.label} (${marker.version})`;
}
